const LANGUAGE_FADE_OUT_MS = 170;
const LANGUAGE_FADE_IN_DELAY_MS = 90;

let isLanguageTransitionInProgress = false;

const wait = (ms) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });

export const getLocalizedPath = ({ pathname, search = "", hash = "" }, lng) => {
  const basePath = pathname.replace(/^\/en(?=\/|$)/, "") || "/";

  if (lng === "en") {
    return `/en${basePath === "/" ? "" : basePath}${search}${hash}`;
  }

  return `${basePath}${search}${hash}`;
};

export const switchLanguageWithFade = async ({
  lng,
  i18n,
  location,
  navigate,
}) => {
  if (!lng || !i18n || !location || !navigate) return false;
  if (isLanguageTransitionInProgress || lng === i18n.language) return false;

  isLanguageTransitionInProgress = true;
  const targetPath = getLocalizedPath(location, lng);

  if (typeof document !== "undefined") {
    document.body.classList.add("lang-fade");
  }

  try {
    await wait(LANGUAGE_FADE_OUT_MS);
    await i18n.changeLanguage(lng);
    navigate(targetPath);
    await wait(LANGUAGE_FADE_IN_DELAY_MS);
    return true;
  } finally {
    if (typeof document !== "undefined") {
      document.body.classList.remove("lang-fade");
    }
    isLanguageTransitionInProgress = false;
  }
};
